/* Verhuisd uit sections/single-product.liquid: stond als inline script in het
   document (parse vóór de eerste paint). Liquid-waarden komen uit window.FLORAFY_PDP,
   gezet door de sectie vlak vóór deze scripts. */
var cfg = window.FLORAFY_PDP || {};
/**
 * Price Breakdown Toggle & Pot Selection Display
 */
(function() {
  'use strict';

  // Currency symbol based on selected country (falls back to €)
  const currencySymbol = cfg.currencySymbol;

  // Helper function to format price with correct currency
  function formatPrice(cents) {
    return window.florafyFormatMoney(cents);
  }

  function updateFillingAddonPriceNote(variantId) {
    const note = document.querySelector('.js-filling-addon-price-note');
    const priceData = document.querySelector('.js-variant-price-data');
    if (!note || !priceData || !variantId) return;

    const variantSpan = priceData.querySelector('[data-variant-id="' + variantId + '"]');
    if (!variantSpan) return;

    const currentPrice = parseInt(variantSpan.dataset.price || 0, 10);
    const addonPrice = parseInt(variantSpan.dataset.addonPrice || 0, 10);
    const standaloneEl = note.querySelector('.js-filling-addon-standalone');
    const addonEl = note.querySelector('.js-filling-addon-price');

    note.dataset.currentPrice = currentPrice;
    note.dataset.addonPrice = addonPrice;

    if (addonPrice > 0 && addonPrice < currentPrice) {
      if (standaloneEl) standaloneEl.textContent = note.dataset.standaloneLabel + ' ' + formatPrice(currentPrice);
      if (addonEl) addonEl.textContent = note.dataset.addonLabel + ' ' + formatPrice(addonPrice);
      note.style.display = '';
    } else {
      note.style.display = 'none';
    }
  }

  window.updateFillingAddonPriceNote = updateFillingAddonPriceNote;

  document.addEventListener('DOMContentLoaded', function() {
    // Price breakdown toggle
    const breakdownToggle = document.querySelector('.js-price-breakdown-toggle');
    const breakdownDetails = document.querySelector('.js-price-breakdown-details');

    if (breakdownToggle && breakdownDetails) {
      breakdownToggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        breakdownDetails.style.display = isExpanded ? 'none' : 'block';
      });
    }

    // Selected pot display update — use event delegation so dynamically loaded pots also work
    const selectedPotDisplay = document.querySelector('.js-selected-pot-display');
    const potSlider = document.querySelector('.js-oppot-slider');

    if (selectedPotDisplay && potSlider) {
      potSlider.addEventListener('click', function(e) {
        if (e.target.closest('.js-select-pot')) {
          // Small delay to let the PotFinder handle the selection first
          setTimeout(function() {
            updateSelectedPotDisplay();
            updatePriceBreakdown();
            updateSimpleTotal();
            updateFillingRecommendation(false);
          }, 50);
        }
      });
    }

    const fillingConfig = document.querySelector('.js-filling-config');
    const fillingMaterials = fillingConfig ? fillingConfig.querySelectorAll('.js-filling-material') : [];
    const fillingDetails = fillingConfig ? fillingConfig.querySelectorAll('.js-filling-detail') : [];

    function getSelectedFillingVariant() {
      const selectedMaterial = document.querySelector('.js-filling-material:checked');
      if (!selectedMaterial || !selectedMaterial.value) return null;
      return document.querySelector('.js-filling-variant:checked[data-material-id="' + selectedMaterial.value + '"]');
    }

    function getFillingQuantity() {
      const selectedVariant = getSelectedFillingVariant();
      const activeDetail = selectedVariant ? selectedVariant.closest('.js-filling-detail') : null;
      const quantityInput = activeDetail ? activeDetail.querySelector('.js-filling-quantity') : null;
      if (!quantityInput) return 1;
      const qty = parseInt(quantityInput.value, 10);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    function getFillingQuantityInputFromControl(control) {
      const activeDetail = control ? control.closest('.js-filling-detail') : null;
      return activeDetail ? activeDetail.querySelector('.js-filling-quantity') : null;
    }

    function getRecommendedFillingVariant(detail) {
      if (!detail) return null;
      const variants = Array.from(detail.querySelectorAll('.js-filling-variant'));
      if (variants.length === 0) return null;

      const checkedPot = document.querySelector('input[name="addExtraPot"]:checked');
      const diameter = parseFloat(checkedPot?.dataset.diameter || '');
      let index = 0;

      if (Number.isFinite(diameter)) {
        if (diameter <= 25) index = 0;
        else if (diameter <= 35) index = Math.min(1, variants.length - 1);
        else index = variants.length - 1;
      }

      return variants[index] || variants[0];
    }

    function updateFillingCards() {
      if (!fillingConfig) return;
      fillingConfig.querySelectorAll('.filling-card').forEach(card => {
        const input = card.querySelector('.js-filling-material');
        card.classList.toggle('is-selected', !!input?.checked);
      });
      fillingConfig.querySelectorAll('.filling-chip').forEach(chip => {
        const input = chip.querySelector('.js-filling-variant');
        chip.classList.toggle('is-selected', !!input?.checked);
      });
    }

    function updateFillingSummary() {
      if (!fillingConfig) return;
      const selectedVariant = getSelectedFillingVariant();
      fillingDetails.forEach(detail => {
        const summary = detail.querySelector('.js-filling-summary');
        if (!summary) return;

        if (!selectedVariant || detail.dataset.materialId !== selectedVariant.dataset.materialId) {
          summary.textContent = '';
          return;
        }

        const qty = getFillingQuantity();
        const addonPrice = parseInt(selectedVariant.dataset.addonPrice || 0, 10);
        const originalPrice = parseInt(selectedVariant.dataset.originalPrice || 0, 10);
        summary.textContent = cfg.fillingSummaryPrefix + ': ' +
          qty + ' × ' + formatPrice(addonPrice) + ' (' +
          cfg.fillingStandalonePriceLower + ' ' +
          formatPrice(originalPrice) + ')';
      });
    }

    function updateFillingRecommendation(markUserSelected) {
      if (!fillingConfig) return;

      const selectedMaterial = document.querySelector('.js-filling-material:checked');
      fillingDetails.forEach(detail => {
        const isActive = selectedMaterial && selectedMaterial.value && detail.dataset.materialId === selectedMaterial.value;
        detail.hidden = !isActive;

        if (!isActive) return;

        if (markUserSelected) {
          detail.dataset.userSelected = 'true';
        }

        const selectedVariant = detail.querySelector('.js-filling-variant:checked');
        if (!selectedVariant || detail.dataset.userSelected !== 'true') {
          const recommended = getRecommendedFillingVariant(detail);
          if (recommended) recommended.checked = true;
        }

        const recommendation = detail.querySelector('.js-filling-recommendation');
        const checkedPot = document.querySelector('input[name="addExtraPot"]:checked');
        const potDiameter = checkedPot?.dataset.diameter;
        const activeVariant = detail.querySelector('.js-filling-variant:checked');
        if (recommendation && activeVariant) {
          if (potDiameter) {
            recommendation.textContent = cfg.fillingRecommendedForPot + ' (Ø ' + potDiameter + ' cm)';
            recommendation.hidden = false;
          } else {
            recommendation.textContent = '';
            recommendation.hidden = true;
          }
        }
      });

      updateFillingCards();
      updateFillingSummary();
      updatePriceBreakdown();
    }

    fillingMaterials.forEach(input => {
      input.addEventListener('change', function() {
        fillingDetails.forEach(detail => {
          if (detail.dataset.materialId === this.value) {
            detail.dataset.userSelected = 'false';
          }
        });
        updateFillingRecommendation(false);
      });
    });

    if (fillingConfig) {
      fillingConfig.querySelectorAll('.js-filling-variant').forEach(input => {
        input.addEventListener('change', function() {
          const detail = this.closest('.js-filling-detail');
          if (detail) detail.dataset.userSelected = 'true';
          updateFillingRecommendation(true);
        });
      });

      fillingConfig.querySelectorAll('.js-filling-qty-minus').forEach(btn => {
        btn.addEventListener('click', function() {
          const quantityInput = getFillingQuantityInputFromControl(this);
          if (!quantityInput) return;
          const currentQty = parseInt(quantityInput.value, 10) || 1;
          quantityInput.value = Math.max(1, currentQty - 1);
          updateFillingSummary();
          updatePriceBreakdown();
        });
      });

      fillingConfig.querySelectorAll('.js-filling-qty-plus').forEach(btn => {
        btn.addEventListener('click', function() {
          const quantityInput = getFillingQuantityInputFromControl(this);
          if (!quantityInput) return;
          const currentQty = parseInt(quantityInput.value, 10) || 1;
          quantityInput.value = currentQty + 1;
          updateFillingSummary();
          updatePriceBreakdown();
        });
      });

      fillingConfig.querySelectorAll('.js-filling-quantity').forEach(input => {
        input.addEventListener('input', function() {
          if (parseInt(this.value, 10) < 1) this.value = 1;
          updateFillingSummary();
          updatePriceBreakdown();
        });
      });
    }

    // Potting checkbox change
    const pottingCheckboxes = document.querySelectorAll('.js-potting-checkbox');
    pottingCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        setTimeout(updatePriceBreakdown, 50);
      });
    });

    // Greeting card checkbox change
    const greetingCardCheckboxes = document.querySelectorAll('.js-greeting-card-toggle');
    greetingCardCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        setTimeout(updatePriceBreakdown, 50);
      });
    });

    // Simple total price calculator for products without pot configurator
    const simpleTotal = document.querySelector('.js-simple-total');
    function updateSimpleTotal() {
      if (!simpleTotal) return;
      const qty = parseInt(document.querySelector('.cart-item-quantity__input[name="quantity"]')?.value || 1);
      const unitPrice = parseInt(simpleTotal.dataset.unitPrice) || 0;
      const comparePrice = parseInt(simpleTotal.dataset.comparePrice) || 0;

      // Volume discount
      let discountPercent = 0;
      if (qty >= 3) discountPercent = 10;
      else if (qty >= 2) discountPercent = 5;

      const subtotal = unitPrice * qty;
      const discountAmount = Math.round(subtotal * discountPercent / 100);
      const total = subtotal - discountAmount;

      // Update label
      const label = simpleTotal.querySelector('.js-simple-total-label');
      if (label) label.textContent = qty + '× ' + label.textContent.replace(/^\d+×\s*/, '');

      // Update subtotal
      const subtotalEl = simpleTotal.querySelector('.js-simple-total-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatPrice(subtotal);

      // Update discount row
      const discountRow = simpleTotal.querySelector('.js-simple-total-discount');
      if (discountRow) {
        discountRow.style.display = discountPercent > 0 ? '' : 'none';
        const discountLabel = simpleTotal.querySelector('.js-simple-total-discount-label');
        const volumeDiscountLabel = cfg.volumeDiscountTitle;
        if (discountLabel) discountLabel.textContent = volumeDiscountLabel + ' (-' + discountPercent + '%)';
        const discountAmountEl = simpleTotal.querySelector('.js-simple-total-discount-amount');
        if (discountAmountEl) discountAmountEl.textContent = '-' + formatPrice(discountAmount);
      }

      // Update total
      const totalEl = simpleTotal.querySelector('.js-simple-total-price');
      if (totalEl) totalEl.textContent = formatPrice(total);

      window.dispatchEvent(new CustomEvent('florafy:configuration-price-update', {
        detail: {
          total: total,
          compare: discountPercent > 0 ? subtotal : 0
        }
      }));

      // Show/hide: only show when qty > 1
      simpleTotal.style.display = qty > 1 ? '' : 'none';
    }

    // Quantity change listeners - find ALL quantity selectors and attach handlers
    // PotFinder handles +/- for products WITH pot configurator; for products WITHOUT,
    // we need to handle the actual quantity change here as well.
    const hasPotConfigurator = !!document.getElementById('find_my_pot_configurator');
    const quantityContainers = document.querySelectorAll('.product-quantity');

    quantityContainers.forEach(function(container) {
      const input = container.querySelector('.cart-item-quantity__input[name="quantity"]');
      const minusBtn = container.querySelector('.cart-item-quantity__btns.is-min');
      const plusBtn = container.querySelector('.cart-item-quantity__btns.is-plus');

      if (!input) return;

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          if (!hasPotConfigurator) {
            const val = parseInt(input.value, 10) || 1;
            if (val > 1) input.value = val - 1;
          }
          setTimeout(function() {
            updateSelectedPotDisplay();
            updatePriceBreakdown();
            updateSimpleTotal();
          }, 100);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          if (!hasPotConfigurator) {
            const val = parseInt(input.value, 10) || 1;
            input.value = val + 1;
          }
          setTimeout(function() {
            updateSelectedPotDisplay();
            updatePriceBreakdown();
            updateSimpleTotal();
          }, 100);
        });
      }

      // Also listen to input changes for manual edits
      if (input) {
        input.addEventListener('input', function() {
          if (parseInt(this.value, 10) < 1) this.value = 1;
          setTimeout(function() {
            updateSelectedPotDisplay();
            updatePriceBreakdown();
            updateSimpleTotal();
          }, 50);
        });
        input.addEventListener('change', function() {
          if (parseInt(this.value, 10) < 1) this.value = 1;
          setTimeout(function() {
            updateSelectedPotDisplay();
            updatePriceBreakdown();
            updateSimpleTotal();
          }, 50);
        });
      }
    });

    function updateSelectedPotDisplay() {
      if (!selectedPotDisplay) return;

      const checkedPot = document.querySelector('input[name="addExtraPot"]:checked');
      const displayLabel = selectedPotDisplay.querySelector('.selected-pot-display__label');
      const plantQuantity = parseInt(document.querySelector('.cart-item-quantity__input[name="quantity"]')?.value || 1);

      // Check if a pot is selected to include in total item count
      const hasPotSelected = checkedPot && checkedPot.value;

      if (checkedPot && checkedPot.value) {
        // Get pot info from the quickview toggle
        const potContainer = checkedPot.closest('.related-pots');
        const quickviewToggle = potContainer ? potContainer.querySelector('.js-quickview-toggle') : null;

        if (quickviewToggle) {
          const potTitle = quickviewToggle.dataset.title || 'Pot';
          const potPrice = parseInt(quickviewToggle.dataset.price || 0);
          const formattedPrice = formatPrice(potPrice);

          const perPieceText = cfg.perPiece;
          const priceHtml = formattedPrice + ' ' + perPieceText;

          displayLabel.innerHTML = '<strong>' + potTitle + '</strong> - ' + priceHtml;
          selectedPotDisplay.classList.add('selected-pot-display--has-pot');
        }
      } else {
        displayLabel.textContent = cfg.noPotSelected;
        selectedPotDisplay.classList.remove('selected-pot-display--has-pot');
      }
    }

    function updatePriceBreakdown() {
      const plantPrice = parseInt(document.querySelector('.js-plant-configuration')?.dataset.price || 0);
      const priceBreakdown = document.querySelector('.js-price-breakdown');
      const plantComparePrice = parseInt(priceBreakdown?.dataset.plantComparePrice || 0);
      const breakdownTotal = document.querySelector('.js-price-breakdown-total');
      const breakdownCompare = document.querySelector('.js-price-breakdown-compare');
      const breakdownPlantName = document.querySelector('.js-breakdown-plant-name');
      const breakdownPlantPrice = document.querySelector('.js-breakdown-plant-price');
      const breakdownPlantCompare = document.querySelector('.js-breakdown-plant-compare');
      const breakdownPot = document.querySelector('.js-breakdown-pot');
      const breakdownPotName = document.querySelector('.js-breakdown-pot-name');
      const breakdownPotPrice = document.querySelector('.js-breakdown-pot-price');
      const breakdownPotCompare = document.querySelector('.js-breakdown-pot-compare');
      const breakdownPotting = document.querySelector('.js-breakdown-potting');
      const breakdownPottingName = document.querySelector('.js-breakdown-potting-name');
      const breakdownPottingPrice = document.querySelector('.js-breakdown-potting-price');
      const breakdownPottingCompare = document.querySelector('.js-breakdown-potting-compare');
      const breakdownFilling = document.querySelector('.js-breakdown-filling');
      const breakdownFillingName = document.querySelector('.js-breakdown-filling-name');
      const breakdownFillingPrice = document.querySelector('.js-breakdown-filling-price');
      const breakdownFillingCompare = document.querySelector('.js-breakdown-filling-compare');
      const breakdownCardPrice = document.querySelector('.js-breakdown-card-price');

      // Get quantity from the input
      const quantityInput = document.querySelector('.cart-item-quantity__input[name="quantity"]');
      const quantity = parseInt(quantityInput?.value || 1);

      // Calculate volume discount based on PLANT quantity only (not pots)
      let volumeDiscountPercent = 0;
      if (quantity >= 3) {
        volumeDiscountPercent = 0.10; // 10% off for 3+ plants
      } else if (quantity >= 2) {
        volumeDiscountPercent = 0.05; // 5% off for 2 plants
      }
      const discountMultiplier = 1 - volumeDiscountPercent;

      // Update plant name with quantity
      if (breakdownPlantName) {
        const baseTitle = breakdownPlantName.dataset.baseTitle || breakdownPlantName.textContent;
        const plantQtyLabel = quantity > 1 ? ' (×' + quantity + ')' : '';
        breakdownPlantName.textContent = baseTitle + plantQtyLabel;
      }

      // Update plant price line (with volume discount)
      if (breakdownPlantPrice) {
        const plantTotal = plantPrice * quantity;
        const discountedPlantTotal = volumeDiscountPercent > 0 ? Math.round(plantTotal * discountMultiplier) : plantTotal;
        breakdownPlantPrice.textContent = formatPrice(discountedPlantTotal);

        // Show/update the compare price (original price before volume discount)
        if (breakdownPlantCompare) {
          if (volumeDiscountPercent > 0 || plantComparePrice > plantPrice) {
            // Show the original price (without discount) - use compare price if exists, otherwise plant price
            const originalPlantTotal = (plantComparePrice > plantPrice ? plantComparePrice : plantPrice) * quantity;
            breakdownPlantCompare.textContent = formatPrice(originalPlantTotal);
            breakdownPlantCompare.style.display = '';
          } else {
            breakdownPlantCompare.style.display = 'none';
          }
        }
      }

      let potPrice = 0;
      let potComparePrice = 0;
      let pottingPrice = 0;
      let fillingAddonPrice = 0;
      let fillingOriginalPrice = 0;
      let fillingQty = 1;
      let fillingTotal = 0;
      let fillingOriginalTotal = 0;

      // Get selected pot (pot quantity matches plant quantity)
      const checkedPot = document.querySelector('input[name="addExtraPot"]:checked');

      if (checkedPot && checkedPot.value) {
        potPrice = parseInt(checkedPot.dataset.potPrice || 0);
        potComparePrice = parseInt(checkedPot.dataset.potComparePrice || 0);

        const potContainer = checkedPot.closest('.related-pots');
        const quickviewToggle = potContainer ? potContainer.querySelector('.js-quickview-toggle') : null;
        const potTitle = quickviewToggle ? quickviewToggle.dataset.title : 'Pot';

        // Pot quantity label (show ×N if more than 1) - pot qty = plant qty
        const potQtyLabel = quantity > 1 ? ' (×' + quantity + ')' : '';

        if (breakdownPot) {
          breakdownPot.style.display = 'flex';
          if (breakdownPotName) breakdownPotName.textContent = potTitle + potQtyLabel;
          const potTotal = potPrice * quantity;
          if (breakdownPotPrice) breakdownPotPrice.textContent = formatPrice(potTotal);
          if (breakdownPotCompare) {
            // Toon de adviesprijs (compare-at) van de pot doorgestreept, net als in de winkelwagen
            if (potComparePrice > potPrice) {
              breakdownPotCompare.textContent = formatPrice(potComparePrice * quantity);
              breakdownPotCompare.style.display = '';
            } else {
              breakdownPotCompare.style.display = 'none';
            }
          }
        }
      } else {
        if (breakdownPot) breakdownPot.style.display = 'none';
      }

      // Get selected potting
      const checkedPotting = document.querySelector('.js-potting-checkbox:checked');
      if (checkedPotting) {
        pottingPrice = parseInt(checkedPotting.dataset.pottingPrice || 0);

        if (breakdownPotting) {
          breakdownPotting.style.display = 'flex';

          // Update potting name with quantity
          if (breakdownPottingName) {
            const baseTitle = breakdownPottingName.dataset.baseTitle || breakdownPottingName.textContent;
            const pottingQtyLabel = quantity > 1 ? ' (×' + quantity + ')' : '';
            breakdownPottingName.textContent = baseTitle + pottingQtyLabel;
          }

          const pottingTotal = pottingPrice * quantity;
          if (breakdownPottingPrice) breakdownPottingPrice.textContent = formatPrice(pottingTotal);
          if (breakdownPottingCompare) {
            breakdownPottingCompare.style.display = 'none';
          }
        }
      } else {
        if (breakdownPotting) breakdownPotting.style.display = 'none';
      }

      const selectedFillingVariant = getSelectedFillingVariant();
      if (selectedFillingVariant) {
        fillingQty = getFillingQuantity();
        fillingAddonPrice = parseInt(selectedFillingVariant.dataset.addonPrice || 0, 10);
        fillingOriginalPrice = parseInt(selectedFillingVariant.dataset.originalPrice || 0, 10);
        fillingTotal = fillingAddonPrice * fillingQty;
        fillingOriginalTotal = fillingOriginalPrice * fillingQty;

        if (breakdownFilling) {
          const productTitle = selectedFillingVariant.dataset.productTitle || cfg.fillingTitle;
          const variantTitle = selectedFillingVariant.dataset.variantTitle || '';
          const qtyLabel = fillingQty > 1 ? ' (×' + fillingQty + ')' : '';
          breakdownFilling.style.display = 'flex';
          if (breakdownFillingName) {
            breakdownFillingName.textContent = (productTitle + ' ' + variantTitle).trim() + qtyLabel;
          }
          if (breakdownFillingPrice) {
            breakdownFillingPrice.textContent = formatPrice(fillingTotal);
          }
          if (breakdownFillingCompare) {
            if (fillingOriginalPrice > fillingAddonPrice) {
              breakdownFillingCompare.textContent = formatPrice(fillingOriginalTotal);
              breakdownFillingCompare.style.display = '';
            } else {
              breakdownFillingCompare.style.display = 'none';
            }
          }
        }
      } else if (breakdownFilling) {
        breakdownFilling.style.display = 'none';
      }

      // Get greeting card
      const breakdownCard = document.querySelector('.js-breakdown-card');
      const greetingCardCheckbox = document.querySelector('.js-greeting-card-toggle:checked');
      const cardPriceEl = document.querySelector('.greeting-card-section[data-card-price-cents]');
      const cardPrice = cardPriceEl ? parseInt(cardPriceEl.dataset.cardPriceCents, 10) : 0;

      if (greetingCardCheckbox) {
        if (breakdownCard) {
          breakdownCard.style.display = 'flex';
          // Card is always 1x, no volume discount applies
          if (breakdownCardPrice) breakdownCardPrice.textContent = formatPrice(cardPrice);
        }
      } else {
        if (breakdownCard) breakdownCard.style.display = 'none';
      }

      // Update volume discount line in breakdown
      const breakdownVolumeDiscount = document.querySelector('.js-breakdown-volume-discount');
      const breakdownVolumePercent = document.querySelector('.js-breakdown-volume-percent');
      const breakdownVolumeAmount = document.querySelector('.js-breakdown-volume-amount');

      // Calculate total price
      const checkedPotForTotal = document.querySelector('input[name="addExtraPot"]:checked');
      const hasPotForTotal = checkedPotForTotal && checkedPotForTotal.value;
      const plantTotal = plantPrice * quantity;
      const discountedPlantTotal = volumeDiscountPercent > 0 ? Math.round(plantTotal * discountMultiplier) : plantTotal;
      const potTotal = hasPotForTotal ? potPrice * quantity : 0;
      const pottingTotal = pottingPrice * quantity;
      const cardTotal = greetingCardCheckbox ? cardPrice : 0;
      const totalPrice = discountedPlantTotal + potTotal + pottingTotal + cardTotal + fillingTotal;
      const originalTotal = plantTotal + potTotal + pottingTotal + cardTotal + fillingTotal;
      const volumeDiscountSavings = plantTotal - discountedPlantTotal;

      // Update volume discount line in breakdown
      if (breakdownVolumeDiscount) {
        if (volumeDiscountPercent > 0 && volumeDiscountSavings > 0) {
          breakdownVolumeDiscount.style.display = 'flex';
          if (breakdownVolumePercent) {
            breakdownVolumePercent.textContent = '(-' + Math.round(volumeDiscountPercent * 100) + '%)';
          }
          if (breakdownVolumeAmount) {
            breakdownVolumeAmount.textContent = '-' + formatPrice(volumeDiscountSavings);
          }
        } else {
          breakdownVolumeDiscount.style.display = 'none';
        }
      }

      // Calculate total compare price (use plant compare price if available, otherwise plant price)
      const baseComparePrice = plantComparePrice > plantPrice ? plantComparePrice : plantPrice;
      const totalComparePrice = (baseComparePrice * quantity) +
                                (hasPotForTotal ? (potComparePrice > potPrice ? potComparePrice : potPrice) * quantity : 0) +
                                (pottingPrice * quantity) +
                                (greetingCardCheckbox ? cardPrice : 0) +
                                (selectedFillingVariant && fillingOriginalPrice > fillingAddonPrice ? fillingOriginalTotal : fillingTotal);

      // Update total
      if (breakdownTotal) {
        breakdownTotal.textContent = formatPrice(totalPrice);
      }

      // Update compare price - show if there's a sale, volume discount, or add-on saving
      let stickyComparePrice = 0;
      if (breakdownCompare) {
        if (plantComparePrice > plantPrice || volumeDiscountPercent > 0 || (hasPotForTotal && potComparePrice > potPrice) || (selectedFillingVariant && fillingOriginalPrice > fillingAddonPrice)) {
          stickyComparePrice = Math.max(totalComparePrice, originalTotal);
          breakdownCompare.textContent = formatPrice(stickyComparePrice);
          breakdownCompare.style.display = '';
        } else {
          breakdownCompare.style.display = 'none';
        }
      }

      window.dispatchEvent(new CustomEvent('florafy:configuration-price-update', {
        detail: {
          total: totalPrice,
          compare: stickyComparePrice
        }
      }));
    }

    // Initial update
    setTimeout(function() {
      updateFillingRecommendation(false);
      updateSelectedPotDisplay();
      updatePriceBreakdown();
    }, 100);

    // Listen for reset event from PotFinder
    document.addEventListener('potfinder:reset', function() {
      updateSelectedPotDisplay();
      updatePriceBreakdown();
    });
  });
})();
